import React from 'react';

import styles from './Maintenance.module.scss';

const Maintenance = ({ config }) => {
	return (
		<div className={styles.wrapper}>
			{config.maintenance}
		</div>
	);
};

export default Maintenance;